import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import common from './de/translation-de-DE.json'
import { privateTooltips } from './de/private-tooltips'
import { professionalTooltips } from './de/professional-tooltips'

import commonEn from './en/translation-en-US.json'
import { privateTooltips as privateTooltipsEn } from './en/private-tooltips'
import { professionalTooltips as professionalTooltipsEn } from './en/professional-tooltips'

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      de: { common: common, private: privateTooltips, professional: professionalTooltips },
      en: { common: commonEn, private: privateTooltipsEn, professional: professionalTooltipsEn },
    },
    defaultNS: 'common',
    react: {
      // Wrap text nodes in a span. By default, text nodes are not wrapped.
      // Used to work around a well-known Google Translate issue with React apps. See https://github.com/facebook/react/issues/11538
      transWrapTextNodes: 'span',
      useSuspense: true,
    },
    returnNull: false,
    detection: {
      order: ['querystring', 'cookie', 'navigator', 'localStorage', 'sessionStorage', 'htmlTag', 'path', 'subdomain'],
    },
  })

export default i18n
